module.exports = __webpack_public_path__ + "static/media/yaman.1ceb9eac.jpg";